/**
 * @generated SignedSource<<17fadcc56beee78dec26da2b26339c8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type insuranceServicePlanQuery$variables = {
  insuranceid: string;
};
export type insuranceServicePlanQuery$data = {
  readonly insurance_agent_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly insurance_org: {
          readonly expireddate: any | null | undefined;
          readonly id: string;
          readonly managerid: string;
          readonly numberofperson: number | null | undefined;
          readonly orgId: string;
          readonly palnType: number;
          readonly valid: boolean;
        } | null | undefined;
        readonly name: string;
        readonly orgid: string | null | undefined;
        readonly personalplanexpireddate: any | null | undefined;
        readonly plantype: number;
      };
    }>;
  };
};
export type insuranceServicePlanQuery = {
  response: insuranceServicePlanQuery$data;
  variables: insuranceServicePlanQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "insuranceid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "insuranceid"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_agentConnection",
    "kind": "LinkedField",
    "name": "insurance_agent_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_agentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_agent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orgid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "personalplanexpireddate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "plantype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "insurance_org",
                "kind": "LinkedField",
                "name": "insurance_org",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expireddate",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "orgId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberofperson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "palnType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "valid",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "insuranceServicePlanQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "insuranceServicePlanQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ef7aebd042ec870d016f4aee5b1ad6f5",
    "id": null,
    "metadata": {},
    "name": "insuranceServicePlanQuery",
    "operationKind": "query",
    "text": "query insuranceServicePlanQuery(\n  $insuranceid: String!\n) {\n  insurance_agent_connection(where: {id: {_eq: $insuranceid}}) {\n    edges {\n      node {\n        id\n        name\n        orgid\n        personalplanexpireddate\n        plantype\n        insurance_org {\n          expireddate\n          id\n          managerid\n          orgId\n          numberofperson\n          palnType\n          valid\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bea745f5d024cda751e8cf4fd7300f9f";

export default node;
